import { render, staticRenderFns } from "./RegisterLesson.vue?vue&type=template&id=08cc78cf&scoped=true&"
import script from "./RegisterLesson.vue?vue&type=script&lang=js&"
export * from "./RegisterLesson.vue?vue&type=script&lang=js&"
import style0 from "./RegisterLesson.vue?vue&type=style&index=0&id=08cc78cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cc78cf",
  null
  
)

export default component.exports